import styled from "styled-components";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const DashboardCard = styled(Link)`
  width: 100%;
  height: 130px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);
  text-decoration: none;
  position: relative;
  overflow: hidden;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  padding: 16px 20px;
  box-sizing: border-box;

  /* Accent color bar on the side */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    width: 6px;
    background-color: ${({ accentColor }) => accentColor || "#cbd5e1"};
    left: ${(props) => (props.lang === "ar" ? "auto" : "0")};
    right: ${(props) => (props.lang === "ar" ? "0" : "auto")};
    transition: width 0.2s ease;
  }

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.08);
    border-color: #cbd5e1;
    &::before {
      width: 10px;
    }
  }

  @media (max-width: 600px) {
    height: auto;
    padding: 16px;
  }
`;

export default function DashboardCardComponent({
  to,
  children,
  accentColor,
  style = {},
}) {
  const { i18n } = useTranslation();

  return (
    <DashboardCard
      to={to}
      lang={i18n.language}
      accentColor={accentColor}
      style={style}
    >
      {children}
    </DashboardCard>
  );
}
